import { rand } from '../../shared/utils/generic';
import { Column, Row, DataTypes } from './datatable.models';
export const DatatableTestData: { columns: Column[]; rows: Row[] } = {
	columns: [
		{
			header: 'Accounts',
			sortable: false,
			tooltip: 'Account number',
			show: true,
			isMandatory: true,
			showForLargeScreen: true,
			showForMediumScreen: true,
			showForSmallScreen: true,
			dataType: DataTypes.string,
			fixed: true,
			main: true,
			noneditable: true,
			style: {
				'min-width': '130px'
			}
		},
		{
			header: 'Total Funds',
			sortable: true,
			show: true,
			showForLargeScreen: true,
			showForMediumScreen: true,
			showForSmallScreen: false,
			dataType: DataTypes.number,
			fixed: false,
			style: {
				'min-width': '105px'
			}
		},
		{
			header: 'Currency',
			sortable: false,
			show: true,
			showForLargeScreen: true,
			showForMediumScreen: true,
			showForSmallScreen: true,
			dataType: DataTypes.select,
			selectOptions: [{ label: 'CAD', value: 'cad' }, { label: 'USD', value: 'usd' }],
			style: {
				'min-width': '80px'
			}
		},
		{
			header: 'Return',
			headerGroup: 1,
			headerGroupLabel: 'Income',
			sortable: true,
			show: true,
			showForLargeScreen: true,
			showForMediumScreen: true,
			showForSmallScreen: false,
			dataType: DataTypes.number,
			dataUnit: '%',
			style: {
				'min-width': '75px'
			}
		},
		{
			header: 'Earnings',
			headerGroup: 1,
			headerGroupLabel: 'Income',
			sortable: true,
			show: true,
			showForLargeScreen: true,
			showForMediumScreen: true,
			showForSmallScreen: false,
			dataType: DataTypes.number,
			formatNumber: true,
			formatNumberLang: 'en',
			formatNumberDecimal: 2,
			dataUnit: '$',
			dataUnitPosition: 'left',
			style: {
				'min-width': '120px'
			}
		},
		{
			header: 'Market Value',
			headerGroup: 2,
			headerGroupLabel: 'Value',
			sortable: true,
			show: true,
			showForLargeScreen: true,
			showForMediumScreen: false,
			showForSmallScreen: false,
			dataType: DataTypes.number,
			formatNumber: true,
			formatNumberLang: 'en',
			formatNumberDecimal: 2,
			dataUnit: '$',
			dataUnitPosition: 'left',
			style: {
				'min-width': '120px'
			}
		},
		{
			header: 'Total Value',
			headerGroup: 2,
			headerGroupLabel: 'Value',
			sortable: true,
			show: true,
			isMandatory: true,
			showForLargeScreen: true,
			showForMediumScreen: true,
			showForSmallScreen: true,
			dataType: DataTypes.number,
			formatNumber: true,
			formatNumberLang: 'en',
			formatNumberDecimal: 2,
			dataUnit: '$',
			dataUnitPosition: 'left',
			style: {
				'min-width': '120px'
			}
		},
		{
			header: 'Actions',
			sortable: true,
			show: true,
			showForLargeScreen: true,
			showForMediumScreen: false,
			showForSmallScreen: false,
			dataType: DataTypes.slot,
			style: {
				'min-width': '180px'
			}
		}
	],
	rows: [] // populate with random data
};

for (let i = 0; i <= 50; i++) {
	DatatableTestData.rows.push({
		id: `row${i}`,
		cells: [
			`Account ${rand(100, 999)}`,
			`${rand(1, 99)}`,
			rand(0, 2) === 1 ? 'cad' : 'usd',
			`${rand(0, 9)}.${rand(10, 99)}`,
			`${rand(100, 999999)}.${rand(10, 99)}`,
			`${rand(100, 999999)}.${rand(10, 99)}`,
			`${rand(100, 999999)}.${rand(10, 99)}`,
			''
		],
		expandableRowRef: `expandable${i}`
	});
}

// export default DatatableTestData;
